import { COUNTRIES } from '@modules/settings/my-numbers/purchase-number/constants/purchase-number.constant';
import { COUNTRY_TIMEZONES } from '@shared/constants/timezones';
import { CallingCodesType, CountryCode } from '@shared/types/utils/timezone.types';

const callingCodes: CallingCodesType = Object.keys(COUNTRY_TIMEZONES).reduce((acc, alpha2Code) => {
  const countryData = COUNTRY_TIMEZONES[alpha2Code as CountryCode];
  const { callingCode } = countryData || {};
  if (!callingCode) return acc;

  if (typeof callingCode === 'string') {
    return {
      ...acc,
      [callingCode]: alpha2Code,
    };
  }

  const combinedCodes = callingCode.reduce(
    (codeAcc, code) => ({
      ...codeAcc,
      [code]: alpha2Code,
    }),
    {}
  );

  return {
    ...acc,
    ...combinedCodes,
  };
}, {});

const sortedCallingCodes = Object.keys(callingCodes).sort((a, b) => b.length - a.length);

export const getCountryCodeByPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return;
  if (phoneNumber.startsWith('+')) phoneNumber = phoneNumber.slice(1);

  for (const callingCode of sortedCallingCodes) {
    if (callingCode && phoneNumber.startsWith(callingCode)) return callingCodes[callingCode];
  }
};

export const getCountryNameFromPhoneNumber = (phoneNumber?: string | null) => {
  if (phoneNumber == null) return null;
  const countryCode = getCountryCodeByPhoneNumber(phoneNumber);
  if (!countryCode) return;
  return COUNTRIES.find((country) => country?.alphaTwoCode === countryCode)?.name;
};

export const replaceDialingCode = (phoneNumber: string, newDialingCode: string) => {
  let localNumber = phoneNumber?.startsWith('+') ? phoneNumber.slice(1) : (phoneNumber ?? '');

  for (const callingCode of sortedCallingCodes) {
    if (callingCode && localNumber.startsWith(callingCode)) {
      localNumber = localNumber.slice(callingCode.length);
      break;
    }
  }

  return `${newDialingCode}${localNumber}`;
};

export const getCallingCodeFromAlpha2Code = (alpha2Code?: string) => {
  alpha2Code = alpha2Code?.toUpperCase();
  const callingCode = COUNTRY_TIMEZONES[alpha2Code as CountryCode]?.callingCode;

  // in case of canada directly return the 1 as calling code
  if (alpha2Code === 'CA') return '1';
  return Array.isArray(callingCode) ? callingCode[0] : callingCode;
};
